<script setup>
import ModalLayout from "@/components/modals/Layouts/ModalLayout.vue";
</script>

<template>
  <ModalLayout>
    <template #header>
      <h2>Згода на cookie</h2>
    </template>

    <p>У кабінеті використовуються cookie для збереження стану сеансу та обраних налаштувань.</p>
  </ModalLayout>
</template>
